import { render, staticRenderFns } from "./tipoInstitucion.vue?vue&type=template&id=21b47f71&scoped=true"
import script from "./tipoInstitucion.vue?vue&type=script&lang=js"
export * from "./tipoInstitucion.vue?vue&type=script&lang=js"
import style0 from "./tipoInstitucion.vue?vue&type=style&index=0&id=21b47f71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b47f71",
  null
  
)

export default component.exports